function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { Translate } from "../../I18N";
import React, { useState } from 'react';








const ImageViewer = (props) => {
  const [errorFlag, setErrorFlag] = useState(false);

  if (errorFlag) {
    return /*#__PURE__*/(
      _jsx("div", { className: "media-error" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This file type is not supported on image fields")
      ));

  }

  return /*#__PURE__*/(
    React.createElement("img", _extends({},
    props, {
      onError: () => {
        setErrorFlag(true);
      } })
    ));

};

export { ImageViewer };